import { useState } from "react";
import classes from "./ContactInformation.module.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useAppContext, ContextConstants } from "../../../Context/AppContext";
import { Card } from "react-bootstrap";
import {
  Constants,
  Activity,
  ActivityString,
  currentRequestTimeStamp,
} from "../../../Constants";
import SubSectionHeader from "../../Shared/SubSectionHeader";
import Input from "../../Shared/Forms/Input";
import {
  replaceValueForKey,
  isValidEmail,
} from "../../../Utility";
import ImageUploader from "../../Shared/ImageUploader";
import userLogoAlt from "../../../Content/images/userFallbackAltImg.svg";
import Button from "../../Shared/Forms/Button";
import deepClone from "lodash.clonedeep";
import TimesCircle from "../../Shared/TimesCircle/TimesCircle";

import mixpanel from "mixpanel-browser";
import { Urls } from "../../../Urls";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { BsTelephoneFill } from "react-icons/bs";
import { TiPlus } from "react-icons/ti";

const ContactInformation = ({ valid = false }) => {
  const { isEditable, transporterInfo, navigatigAway } = useAppContext();
  const { dispatch } = useAppContext();
  const [lastUpdatedTimeStamp, setlastUpdatedTimeStamp] = useState("");

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const checkLastUpdateBy = (user) => {
    var __FLAG__ = false;
    var lastUpdatedList = [];
    lastUpdatedList = transporterInfo["last_updated_by"];
    for (var i = 0; i < lastUpdatedList.length; i++) {
      if (
        lastUpdatedList[lastUpdatedList.length - 1]["contact_number"] ===
        user["contact_number"]
      ) {
        __FLAG__ = true;
        setlastUpdatedTimeStamp(
          lastUpdatedList[lastUpdatedList.length - 1]["timestamp"]
        );
        break;
      }
    }
    return __FLAG__;
  };

  const isLoggedIn = (user) => {
    var __FLAG__ = false;
    if (user["isLoggedIn"] && user["isLoggedIn"] === "yes") {
      __FLAG__ = true;
    }
    return __FLAG__;
  };

  const ContactCard = ({ contact }) => {
    return (
      <Card className={`${classes["s-card-text"]}`}>
        <div className={classes["contact-card"]}>
          <div className={classes["contact-avatar-containar"]}>
            <ImageUploader
              fileId={contact.logo}
              imgClassName={classes["contact-avatar"]}
              imgAlt={userLogoAlt}
            />
          </div>
          <Card.Body className={classes["card-content"]}>
            <Card.Title>
              {contact.name}{" "}
              {isLoggedIn(contact) ? (
                <i
                  title="user has logged in to the profile"
                  style={{ color: "green", fontSize: "75%" }}
                  className="fa fa-check-circle"
                ></i>
              ) : null}{" "}
            </Card.Title>
            <Card.Text>{contact.designation}</Card.Text>
            <hr />
            <Card.Text>
              {contact.poc &&
                contact.poc.toLowerCase() === Constants.Boolean.Yes ? (
                <Button classname={classes["phone-button"]} onClick={() => { }}>
                  <BsTelephoneFill size={10} />
                  <span className="px-2">{contact.contact_number}</span>
                </Button>
              ) : (
                contact.contact_number
              )}
            </Card.Text>
            <Card.Text>{contact.email}</Card.Text>

            {/* <Button variant="primary">Go somewhere</Button> */}
          </Card.Body>
        </div>
        {checkLastUpdateBy(contact) ? (
          <>
            <hr />
            <span align="center">
              <i>
                (Updated the profile on {lastUpdatedTimeStamp.split("T")[0]})
              </i>
            </span>
          </>
        ) : null}
      </Card>
    );
  };

  const EditableContactCard = ({ contact, index }) => {
    const defaultCountry = transporterInfo?.country_code || localStorage.getItem("countryCode") || "IN";

    const onEditCheck = (e) => {
      replaceValueForKey(
        contact,
        "poc",
        e.target.checked ? Constants.Boolean.Yes : Constants.Boolean.No
      );

      return mixpanel.track("User has clicked on point of contact checkbox", {
        // distinct_id: 'unique client id',
        ApplicationName: `${Urls.appnamemixpanel}`,
        ScreenName: "Transporter-Profile",
        ModuleName: "general-information-edit",
        ActivityLog: "userClickedPointOfContactCheckbox",
        Data: `${e.target.checked ? "Yes" : "NO"}`,
        Definition: "User has clicked on point of contact checkbox",
        TransporterName: transporterInfo.transporter_name,
        TransporterId: transporterInfo.transporter_id,
        ActivityType: "event_view",
      });
    };

    return (
      <Card
        className={`${classes["edit-mode-cards-container-card"]} ${classes["s-card-text"]}`}
      >
        {index ? (
          <TimesCircle
            onClick={() => onContactRemove(index)}
            className={classes["close-icon"]}
          />
        ) : null}
        <div className={classes["contact-card"]}>
          <div className={classes["contact-avatar-containar"]}>
            <ImageUploader
              isContact={true}
              fileId={contact.logo}
              isEditable
              onUpload={(fileid) => {
                contact.logo = fileid;
                replaceValueForKey(contact, "logo", fileid);
              }}
              transporterId={transporterInfo.transporter_id}
              imgClassName={classes["contact-avatar"]}
              imgAlt={userLogoAlt}
            />
          </div>
          <Card.Body>
            <Input
              placeholder="Name"
              defaultValue={contact.name}
              onChange={(value) => replaceValueForKey(contact, "name", value)}
              isInvalid={navigatigAway && !contact.name}
              isRequired
            />
            <Input
              placeholder="Designation"
              defaultValue={contact.designation}
              onChange={(value) =>
                replaceValueForKey(contact, "designation", value)
              }
            />
            <PhoneInput
              defaultCountry={defaultCountry}
              international
              value={contact.contact_number}
              onChange={(value) =>
                replaceValueForKey(contact, "contact_number", value)
              }
              limitMaxLength={15}
              placeholder="Contact number"
              className={`${classes["form-input-phone-input"]}`}
              style={{ width: "100%", marginLeft: "-40px" }}
            />
            <Input
              placeholder="Email"
              defaultValue={contact.email}
              onChange={(value) => replaceValueForKey(contact, "email", value)}
              isInvalid={navigatigAway && !isValidEmail(contact.email)}
              isRequired
            />
            <span className={classes["flex-align-center"]}>
              <input
                type="checkbox"
                defaultChecked={
                  contact.poc &&
                  contact.poc.toLowerCase() === Constants.Boolean.Yes
                }
                onChange={(e) => onEditCheck(e)}
              />
              <span>Point of Contact</span>
            </span>
          </Card.Body>
        </div>
      </Card>
    );
  };

  const addNewContact = () => {
    Activity([
      {
        screen: ActivityString.GeneralInfo,
        module: "Contact Information",
        user_activity: ActivityString.AddButton,
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    //setContactsJson([...contactsJson, Constants.NewContact]);
    mixpanel.track("User has clicked on contact information add button", {
      // distinct_id: 'unique client id',
      ApplicationName: `${Urls.appnamemixpanel}`,
      ScreenName: "Transporter-Profile",
      ModuleName: "general-information-edit",
      ActivityLog: "userClickedContactInformationAddButton",
      Data: ``,
      Definition: "User has clicked on contact information add button",
      TransporterName: transporterInfo.transporter_name,
      TransporterId: transporterInfo.transporter_id,
      ActivityType: "event_view",
    });
    transporterInfo.contact_information.push({
      ...deepClone(Constants.NewContact),
    });

    dispatch({
      type: ContextConstants.UpdateContacts,
      payload: transporterInfo.contact_information,
    });
  };

  const onContactRemove = (index) => {
    Activity([
      {
        screen: ActivityString.GeneralInfo,
        module: "Contact Information",
        user_activity: ActivityString.RemoveButton,
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    mixpanel.track("User has clicked on contact information delete button", {
      // distinct_id: 'unique client id',
      ApplicationName: `${Urls.appnamemixpanel}`,
      ScreenName: "Transporter-Profile",
      ModuleName: "general-information-edit",
      ActivityLog: "userClickedContactInformationDeleteButton",
      Data: ``,
      Definition: "User has clicked on contact information delete button",
      TransporterName: transporterInfo.transporter_name,
      TransporterId: transporterInfo.transporter_id,
      ActivityType: "event_view",
    });
    dispatch({
      type: ContextConstants.UpdateContacts,
      payload: deepClone(transporterInfo.contact_information).filter(
        (c, i) => i !== index
      ),
    });
  };

  const AddContactCard = () => {
    return (
      <Card
        className={classes["edit-mode-cards-container-card"]}
        style={{ width: "16rem" }}
      >
        <Card.Body className={`d-flex justify-content-center align-items-center`}>
          <button
            onClick={addNewContact}
            title="Add contact"
            className={`btn btn-sm btn-link`}
          >
            <TiPlus size={15} />
            <span className="">Add</span>
          </button>
        </Card.Body>
      </Card>
    );
  };

  const ReadOnly = ({ contacts }) => {
    return (
      <div>
        <Carousel responsive={responsive}>
          {contacts.map((contact, index) => (
            <ContactCard key={index} contact={contact} />
          ))}
        </Carousel>
      </div>
    );
  };

  const EditMode = ({ contacts }) => {
    return (
      <div>
        {valid === true ? (
          <span style={{ color: "red" }}>
            Atleast 1 Point of Contact Needed
          </span>
        ) : null}
        <div className={classes["edit-mode-cards-container"]}>
          {contacts.map((contact, i) => (
            <EditableContactCard key={i} contact={contact} index={i} />
          ))}
          <AddContactCard></AddContactCard>
        </div>
      </div>
    );
  };

  return (
    <div className={classes.container + " sub-section-container"}>
      <SubSectionHeader title="Contact Information"></SubSectionHeader>

      {transporterInfo && transporterInfo.contact_information ? (
        isEditable ? (
          <EditMode contacts={transporterInfo.contact_information} />
        ) : (
          <ReadOnly contacts={transporterInfo.contact_information} />
        )
      ) : null}
    </div>
  );
};

export default ContactInformation;
